import { Navigate } from 'react-router-dom';
import { useActiveOrgStore } from '@store/index';

/**
 * REV-897: /consultant/clients and /consultant/contexts were retired with the
 * consultant persona (REV-449). Their replacement is the tracked places of the
 * organization chosen in the header — one organization at a time (REV-589) —
 * so old links and bookmarks land there, or on the organizations list when no
 * organization is chosen. Replaces the history entry: the old address is dead.
 */
export default function LegacyConsultantRedirect() {
  const { activeOrg } = useActiveOrgStore();
  const target = activeOrg ? `/orgs/${activeOrg.slug}/contexts` : '/orgs';
  return <Navigate to={target} replace />;
}
